// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ek","header":"el","button":"em","confirmationBox":"en","details":"eo","detail":"ep","detailLabel":"eq","detailImage":"er"};